<template>
    <div>
        <v-btn
                color="primary"
                dark
                @click.stop="dialog = true"
        >
            Create supplier
        </v-btn>

        <v-dialog
                v-model="dialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Create new supplier</v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                    v-validate="'required'"
                                    v-model="data.name"
                                    :error-messages="errors.collect('data.name')"
                                    label="Name"
                                    data-vv-name="data.name"
                                    browser-autocomplete="off"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                    v-validate="'required|email'"
                                    v-model="data.email"
                                    :error-messages="errors.collect('data.email')"
                                    label="E-mail"
                                    data-vv-name="data.email"
                                    @change="checkEmail"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12 v-if="email_usado">
                            <v-alert
                                    :value="true"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                This email is already in use.
                            </v-alert>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialog = false"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="create"
                    >
                        Create
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: ['laboratorio_id'],
        data () {
            return {
                data: {},
                dialog: false,
                error : false,
                message_error : null,
                cliente: null,
                email_usado: false
            }
        },
        watch: {
            dialog: function() {
                if (this.dialog == true) {
                    this.data = {};
                }
            }
        },
        methods: {
            checkEmail () {
                this.$store.dispatch('checkEmail', {
                    email: this.data.email
                }).then((res) => {
                    if (res.data.existe) {
                        this.email_usado = true;
                        this.clientes = res.data.cliente;
                    }
                    if (! res.data.existe) {
                        this.email_usado = false;
                        this.cliente = null;
                    }
                }).catch((error) => {

                });
            },
            create : function() {
                this.$validator.validateAll().then((result) => {
                    if(result && ! this.email_usado){
                        this.data.laboratorio_id = this.laboratorio_id;
                        this.$store.dispatch('createAmc', {
                            data : this.data
                        }).then((res) => {

                            this.dialog = false;

                            this.$emit('update');

                        }).catch((error) => {
                            this.email_usado = true;
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/components/CreateFtnModal.vue